export default __webpack_public_path__ + "static/media/hmmtwo.4b1570b7.png";